import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ApiGo from '../actions/ApiGo';

/* 捉取 api資料 */
// export const fetchBedStatus2ui = createAsyncThunk('todos/fetchBedStatus2ui', async (_id) => {
const fetchBedStatus2ui = createAsyncThunk('todos/fetchBedStatus2ui', async (_id) => {
    try {
        const response = await ApiGo.getBedStatus2ui(_id);
        return response;
    } catch (e) {
        console.error(e.name + ": " + e.message);
    }
})
/* 呼吸資訊 */
export const thunkBedStatus2uiSlice = createSlice({
    name: 'todos',
    initialState: {
        data: null, // API 資料
        test: "test"
    },
    reducers: {
    },
    extraReducers:
        builder => {
            builder
                // 設定-正在抓時
                .addCase(fetchBedStatus2ui.pending, (state, action) => {
                    state.status = 'loading';
                })
                // 設定-抓失敗時
                .addCase(fetchBedStatus2ui.rejected, (state, action) => {
                    state.status = 'reject';
                })
                // 設定-抓成功時要存進 store 中
                .addCase(fetchBedStatus2ui.fulfilled, (state, action) => {
                    state.data = action.payload;
                    state.status = 'idle';
                })
        }
})

export const {
    TEST,
} = thunkBedStatus2uiSlice.actions
export { fetchBedStatus2ui };
export default thunkBedStatus2uiSlice.reducer